/// Renders one of the synced SVG icons, tinted to the current onSurface
/// colour the way flutter_svg's ColorFilter.mode does on mobile.
///
/// CSS masking keeps the SVG a single network request and lets the tint follow
/// the theme without touching the file.

import type { CSSProperties } from 'react';

export type IconSet = 'icons' | 'pixel_icons';

export interface PixelIconProps {
  name: string;
  set?: IconSet;
  size?: number;
  color: string;
  className?: string;
  style?: CSSProperties;
}

export function PixelIcon({
  name,
  set = 'icons',
  size = 24,
  color,
  className = '',
  style,
}: PixelIconProps) {
  const url = `url(/assets/${set}/${name}.svg)`;

  return (
    <span
      aria-hidden
      className={`inline-block shrink-0 ${className}`}
      style={{
        width: size,
        height: size,
        backgroundColor: color,
        maskImage: url,
        WebkitMaskImage: url,
        maskSize: 'contain',
        WebkitMaskSize: 'contain',
        maskRepeat: 'no-repeat',
        WebkitMaskRepeat: 'no-repeat',
        maskPosition: 'center',
        WebkitMaskPosition: 'center',
        ...style,
      }}
    />
  );
}
